import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './ai-charge.reducer'
import * as state from './ai-charge.state'

export const aiChargeState = createFeatureSelector<state.State>('ai-charge')

export const selectAIChargeLoaded = createSelector(aiChargeState, (s: state.State) => s.isLoaded)

export const selectAllAICharges = createSelector(aiChargeState, reducer.selectAll)
